module.exports = __webpack_public_path__ + "static/media/012-email.39ffbfbf.svg";